import React from 'react';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';
import './index.css';

type PromptType = {
    title?: string;
    text?: string;
    buttonText: string;
    onButtonClick: () => void;
    buttonSecondaryText?: string;
    onButtonSecondaryClick?: () => void;
    children?: JSX.Element
};

function Prompt({
    title,
    text,
    buttonText,
    onButtonClick,
    buttonSecondaryText,
    onButtonSecondaryClick,
    children
}: PromptType) {
    if (children) {
        return (
            <>
                <Backdrop />
                <div className='prompt'>
                    {children}    
                </div>  
            </>
        );
    }

    return (
        <>
            <Backdrop />
            <div className='prompt'>
                {title && <h1 className='prompt__title'>{title}</h1>}
                <p className='prompt__text'>{text}</p>
                <div className='prompt__buttonGroup'>
                    <Button
                        className='prompt__button'
                        onClick={onButtonClick}
                    >
                        {buttonText}
                    </Button>
                    {buttonSecondaryText && onButtonSecondaryClick &&
                        <Button
                            className='prompt__button'
                            secondary
                            onClick={onButtonSecondaryClick}
                        >
                            {buttonSecondaryText}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
}

export default Prompt;